'use client';
import { getCTA } from '@/utils/getCTA';
import { getColorScheme } from '@/utils/getColorScheme';
import { isGradientColorScheme } from '@/utils/gradientDirection';
import { Button } from './atoms/Button';

export default function ReviewPage(props) {
    const {
        CTA,
        SecondaryButtonText,
        OutlineButtonText,
        ReviewButtonText,
        ColorScheme = 'light',
        GradientDirection = 'down',
        VerticalSpacing = 'medium',
    } = props;

    const { backgroundColor, thirdButton, secondaryButton, backgroundStyle } =
        getColorScheme(ColorScheme, GradientDirection);

    const vSpace = getVerticalSpacing(VerticalSpacing);
    const { hasAny: hasCTAs, element: CTAs } = getCTA(props, {
        secondaryVariant: secondaryButton,
        outlineVariant: thirdButton,
        wrapSpacing: 'mt-0',
        buttonAlign: 'justify-center',
        buttonsClassName: 'flex flex-wrap items-center justify-center gap-4',
        className: '',
        size: 'md',
    });

    return (
        <div
            className={`editable-component relative ${backgroundColor} ${vSpace}`}
            style={
                isGradientColorScheme(ColorScheme) ? backgroundStyle : undefined
            }
        >
            <div className="relative z-40 mx-auto max-w-7xl px-6 lg:px-8">
                {/*ReviewStories*/}
                <div className="flow-root">
                    <div
                        className="nj-stories"
                        data-filter-media="hide"
                        data-media="hide"
                        data-branding="bottom"
                    ></div>

                    {/* CTA */}
                    <div className="flex w-full justify-center">
                        {(CTA ||
                            SecondaryButtonText ||
                            OutlineButtonText ||
                            ReviewButtonText) && (
                            <div className="relative z-40 mt-10 flex max-w-4xl flex-wrap items-center justify-center gap-4 lg:mt-16">
                                {hasCTAs && CTAs}
                                {ReviewButtonText && (
                                    <Button
                                        variant={thirdButton}
                                        size="md"
                                        type="button"
                                        className="nj-review text-center"
                                    >
                                        {ReviewButtonText}
                                    </Button>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
/* ------------------- Helper Functions ------------------- */

function getVerticalSpacing(spacing) {
    const spacings = {
        large: 'py-36  md:py-44 lg:py-64 xl:py-80 2xl:py-[400px]',
        'large-no-top':
            'pt-10 pb-36  md:pb-44 lg:pb-64 xl:pb-80 2xl:pb-[400px]',
        'large-no-bottom':
            'pb-10 pt-36  md:pt-44 lg:pt-64 xl:pt-80 2xl:pt-[400px]',
        'large-medium-bottom':
            'pb-24 lg:pb-36 pt-36 md:pt-44 lg:pt-64 xl:pt-80 2xl:pt-[400px]',
        'large-medium-top':
            'pt-24 lg:pt-36 pb-36  md:pb-44 lg:pb-64 xl:pb-80 2xl:pb-[400px]',
        none: 'py-10',
        'no-top': 'pb-24 pt-10 lg:pb-36',
        'no-bottom': 'pt-24 pb-10 lg:pt-36',
        medium: 'py-24 lg:py-36',
    };
    return spacings[spacing] || spacings.medium;
}
